import { fetch } from '../'

export default {
  async get (id, key = '') {
    let response = await fetch(`/wp-json/wpvue/v1/customfields/${id}/${key}${window.lang ? '?lang=' + window.lang : ''}`)
    let data = await response.json()
    return response.ok ? data : []
  }
}
